// extracted by mini-css-extract-plugin
export default {"rateModal":"GreenRateModal_rateModal__JiJLk","empty_box":"GreenRateModal_empty_box__jm887","customModal":"GreenRateModal_customModal__n-Omr"};